// extracted by mini-css-extract-plugin
export var orderSummary = "_oj-0";
export var showMoreLessButton = "_oj-1";